const MAX_SAFE_LINE_WIDTH = 150;

const drawMultilineText = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  lineHeight: number
) => {
  const words = text.split(" ");

  const lines: string[] = [];

  let wordsIndex = 0;

  const fillLine = () => {
    do {
      lines[lines.length - 1] += " " + (words[wordsIndex++] || "");
    } while (
      ctx.measureText(lines[lines.length - 1]).width < MAX_SAFE_LINE_WIDTH
    );
  };

  while (wordsIndex < words.length) {
    lines.push("");
    fillLine();
  }

  lines.forEach((line, i) => {
    ctx.fillText(line.trim(), x, y + i * lineHeight);
  });
};

export default drawMultilineText;
